export default __webpack_public_path__ + "static/media/intro-img-bear.47539097.png";